<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zushZ0/tc-custom/9781611522303.jpg?1723404043243" alt="This image is the cover for the book Playing the Field: Victory Lap, Playing the Field"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Playing the Field: Victory Lap, Playing the Field
      </h1>
      <p class="bookDescription body article font2">
        <p>At 33, Josh Helton isn't exactly on top of his game. Overweight and out of shape, he's content with his lazy lifestyle until he starts having chest pains.<br/><br/> <i>That</i> wakes him up. After a hard look at his life, he realizes he isn't where he wants to be. His body needs work, and his love life does, too. Ditching his abusive boyfriend is just the beginning. Josh takes up running to get fit, and promises himself he'll run the annual Richmond 10K.<br/><br/>It's on an early morning jog that he meets Chad, a sexy bicyclist who's everything Josh has always wanted in a guy. But Josh isn't confident in himself any more ... so it's up to Chad to make the first move.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bbeddd1a